import { match as int } from "../../../src/params/int.js";
import { match as lang } from "../../../src/params/lang.js";
import { match as page } from "../../../src/params/page.js";
import { match as service } from "../../../src/params/service.js";
import { match as state } from "../../../src/params/state.js";

export const matchers = { int, lang, page, service, state };